import { formDataConstants } from "@data/constants/formDataConstants"

export function saveActivityData(data) {
    return { type: formDataConstants.SAVE_ACTIVITY, data }
}

export function clearActivityData() {
    return { type: formDataConstants.CLEAR_ACTIVITY }
}

export function setAnswerInput(data) {
    return { type: formDataConstants.SET_ANSWER_INPUT, data }
}

export const saveReportFile = (data) => (dispatch) => {
    dispatch({
        type: formDataConstants.SAVE_REPORT_FILE,
        data,
    })

    return Promise.resolve()
}

export function clearReportFile() {
    return { type: formDataConstants.CLEAR_REPORT_FILE }
}

export function saveFormData(formId, entryId, data) {
    return { type: formDataConstants.SAVE_FORM_DATA, formId, entryId, data }
}

export function resetFormData(formId, entryId) {
    return { type: formDataConstants.RESET_FORM_DATA, formId, entryId }
}

export function saveUploadedFiles(formId, data) {
    return { type: formDataConstants.SAVE_UPLOADED_FILES, formId, data }
}

export function resetUploadedFiles(formId) {
    return { type: formDataConstants.RESET_UPLOADED_FILES, formId }
}
